import React from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";

const MainSlider = ({
  subTitle,
  button,
  title,
  backgroundImage,
  language,
  RedirectUrl,
}) => {
  const navigate = useNavigate();

  return (
    <Swiper navigation={true} modules={[Navigation]} className="mySwiper">
      <SwiperSlide>
        <div
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
          className="slide-slider"
          dir={language === "ar" ? "rtl" : "ltr"}
        >
          <div className="slider-content">
            <span className="slider-sub-title">{subTitle}</span>
            <span className="slider-title">{title}</span>
            <div
              style={{
                width: "60px",
                height: "3px",
                backgroundColor: "#fff",
                margin: "20px auto",
              }}
            ></div>
            <button
              style={{
                backgroundColor: "#fff",
                color: "#000",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                marginTop: "20px",
                width: "196px",
              }}
              className="slider-button"
              onClick={() => navigate(RedirectUrl)}
            >
              {button}
            </button>
          </div>
        </div>
      </SwiperSlide>
    </Swiper>
  );
};

export default MainSlider;
